export enum QuickFilterScope {
    ORDER = "ORDER",
    PICKUP_TASK = "PICKUP_TASK",
    DELIVERY_BATCH = "DELIVERY_BATCH",
    DRIVER_INVOICE = "DRIVER_INVOICE",
    MERCHANT_INVOICE = "MERCHANT_INVOICE",
}